import { render } from "./consumptionDetails.vue?vue&type=template&id=d546d03c&scoped=true"
import script from "./consumptionDetails.vue?vue&type=script&lang=js"
export * from "./consumptionDetails.vue?vue&type=script&lang=js"

import "./consumptionDetails.vue?vue&type=style&index=0&id=d546d03c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d546d03c"

export default script